module.exports = __webpack_public_path__ + "img/team4.a4942bfd.png";